import { gql } from "@apollo/client";
import { isDateRangeIn, taxCalculation } from "./helper";
import { PURCHASABLE_BUFFER } from "@/lib/constants";

export const typeDef = gql`
  type Product {
    id: ID!
    name: String!
    thumbnailUrl: String
    description: String
    product_type: String
    sales_start_at: String
    sales_end_at: String
    price: Int
    priceWithoutTax: Int
    rightIds: [Int]
    purchased: Boolean
    right: Right
    meta: MediaMeta
    purchaseAllowed: Boolean
    voucherCode: VoucherCode
    discountPrice: Int
  }

  type Query {
    productById(id: Int): Product
  }
`;

export const resolvers = {
  Query: {
    productById: async (_parent, args, { dataSources }) => {
      const res = await dataSources.product.productById(args);
      return res;
    },
  },
  Product: {
    id: (product) => product.id || product.product_id,
    thumbnailUrl: (product, _args, { req }) => {
      const noimage = "/images/noimage.png";
      return product.thumbnail_url || noimage;
    },
    price: (product) => product?.active_pricing?.payment_amount,
    priceWithoutTax: (product) => product?.active_pricing?.price,
    rightIds: (product) => product?.right_ids,
    purchased: async (product, _args, { req, dataSources }) => {
      if (!req.userToken) return false;
      if (!product.ref_id) return false;
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      const rightId = right.right_id;
      const { entitlements } = await dataSources.user.entitlementsFromRight([
        rightId,
      ]);
      return entitlements && entitlements.length > 0 ? true : false;
    },
    right: async (product, _args, { dataSources }) => {
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      return right;
    },
    meta: async (product, _args, { dataSources }) => {
      const right = await dataSources.right.rightsByRefId(product.ref_id);
      if (right) {
        const res = await dataSources.meta.searchFromRightId(right.right_id);
        return res?.metas?.[0];
      } else {
        return null;
      }
    },
    purchaseAllowed: (product) => {
      return isDateRangeIn(product?.sales_start_at, product?.sales_end_at, {
        buffer: PURCHASABLE_BUFFER,
        default: true,
      });
    },
    voucherCode: (product) => product?.voucher_code,
    discountPrice: (product) => {
      if (product?.voucher_code) {
        const discount = product.voucher_code.voucher.discount_price;
        const price = product.active_pricing.price;
        if (price <= discount) {
          return 0;
        }
        return taxCalculation(price - discount);
      }
      return null;
    },
  },
};
